import { HtmlWithKatex } from './renderKatex';

/**
 * Tableau statique pour l'impression — elements_additionnels `type: 'table'`,
 * HORS `config.type === 'vraiFaux'` (exclu en amont, géré par PrintVraiFaux).
 *
 * Sur papier, les cellules de réponse sont laissées vides avec bordure :
 * l'élève complète au stylo. Même lecture de config que le renderer élève
 * (TableResponseElementEleve) : `colonnes` = en-têtes, `lignes` = libellés
 * de lignes (peuvent contenir du LaTeX inline `$...$`).
 */
const PrintTable = ({ colonnes = [], lignes = [] }) => {
    if (!Array.isArray(colonnes) || !Array.isArray(lignes)) return null;
    if (colonnes.length === 0 || lignes.length === 0) return null;

    return (
        <table className="ep-table">
            <thead>
                <tr>
                    <th />
                    {colonnes.map((col, i) => (
                        <th key={i}>
                            <HtmlWithKatex as="span" html={String(col)} />
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {lignes.map((ligne, i) => (
                    <tr key={i}>
                        <td className="ep-table-label">
                            <HtmlWithKatex as="span" html={String(ligne)} />
                        </td>
                        {colonnes.map((_, j) => (
                            <td key={j} className="ep-table-cell" />
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default PrintTable;
